import { TbClock, TbHandClick, TbUser } from 'react-icons/tb';

import type { IconTypes } from 'components-new/icon';

type JobType = 'interest' | 'personal' | 'urgent';

const jobTypeToIconMap: Record<JobType, IconTypes | null> = {
  interest: TbHandClick,
  personal: TbUser,
  urgent: TbClock,
};

export default function getIconForJobType(jobType: JobType): IconTypes {
  return jobTypeToIconMap[jobType] || TbUser;
}
